export var ICON_SIZE = 20;
export var ICON_MODS = ["f_auto", "q_auto", "c_pad", "w_" + ICON_SIZE, "h_" + ICON_SIZE];
//# sourceMappingURL=constants.js.map